/* PDP v3 (2026-09-26) — vertical accordion helpers for sections/ame-pdp-main.liquid.
   The sections are native <details>/<summary>, so opening, closing, keyboard activation and the expanded
   state need no script. This file only makes in-page links land on content inside a closed section:
     • a[href^="#tab-"] and [data-jump-to-tab] links open the enclosing <details>, then scroll to it;
     • a URL hash that points inside a section opens it on load;
     • window.AmeAcc.reveal(el) is shared with assets/ame-pdp-state.js (fabric / specs jumps).
   The FAQ question toggles inside the FAQ section are unchanged. */
(function () {
  function reveal(el) {
    var d = el && el.closest ? el.closest('details') : null;
    while (d) { d.open = true; d = d.parentElement ? d.parentElement.closest('details') : null; }
  }
  window.AmeAcc = { reveal: reveal };

  function targetFor(link) {
    var id = link.getAttribute('data-jump-to-tab');
    if (!id) { var href = link.getAttribute('href') || ''; if (href.charAt(0) === '#') id = href.slice(1); }
    return id ? document.getElementById(id) : null;
  }
  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('a[href^="#tab-"], [data-jump-to-tab]') : null;
    if (!link) return;
    var panel = targetFor(link);
    if (!panel) return;
    e.preventDefault();
    reveal(panel);
    var box = panel.closest('details') || panel;
    requestAnimationFrame(function () {
      box.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var sum = box.querySelector ? box.querySelector('summary') : null;
      if (sum) sum.focus({ preventScroll: true });
    });
  });

  function openFromHash() {
    if (!location.hash || location.hash.length < 2) return;
    var el = null;
    try { el = document.getElementById(decodeURIComponent(location.hash.slice(1))); } catch (err) { el = null; }
    if (el) reveal(el);
  }
  openFromHash();
  window.addEventListener('hashchange', openFromHash);

  // FAQ accordion (questions inside the FAQ section)
  document.querySelectorAll('.ame-faq__question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', String(!expanded));
      var answer = document.getElementById(this.getAttribute('aria-controls'));
      if (answer) answer.classList.toggle('is-open');
    });
  });
})();

/* Post-launch 2026-09-28: the section-chip row (.ame-cnav__list) scrolls horizontally with its scrollbar hidden, and
   keyboard focus left chips partly outside it (measured at 320-768px, live and staging). Bring the focused chip fully
   into view; the CSS scroll-margin keeps it clear of the trailing fade. */
(function () {
  var list = document.querySelector('.ame-cnav__list');
  if (!list) return;
  list.addEventListener('focusin', function (e) {
    var li = e.target.closest('li');
    if (li && list.scrollWidth > list.clientWidth) li.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  });
})();
